export interface CarResponse {
  id: number;
  name: string;
  brand: string;
  km: number;
  price: number;
  thumbnail: string;
  year: number;
  yearModel: number;
}

export enum enBrand {
  'fiat' = 'fiat',
  'mercedes' = 'mercedes',
  'mercedes benz' = 'mercedes benz',
  'honda' = 'honda',
  'ford' = 'ford',
  'hyundai' = 'hyundai',
  'toyota' = 'toyota',
  'chevrolet' = 'chevrolet',
  'nissan' = 'nissan',
  'audi' = 'audi',
  'jeep' = 'jeep',
  'peugeot' = 'peugeot',
  'volvo' = 'volvo',
  'renault' = 'renault',
  'mitsubishi' = 'mitsubishi',
  'volkswagen' = 'volkswagen',
  'caoa chery' = 'caoa chery'
}

export interface IVehicleFilters {
  brand?: enBrand;
  startPrice?: number;
  endPrice?: number;
  startYear?: number;
  endYear?: number;
  startKm?: number;
  endKm?: number;
}

export interface IFilterVariables {
  brands: enBrand[];
  maxPrice: number;
  minPrice: number;
  minKM: number;
  maxKM: number;
}

type Vehicles = {
  vehicleId: number;
  position: number;
};

export interface IOrder {
  vehicles: Vehicles[];
}

export enum enTranslateTransmission {
  'manual' = 'manual',
  'automatic' = 'automático',
}

export enum enTranslateColor {
  'white' = 'branco',
  'black' = 'preto',
  'gray' = 'cinza',
  'silver' = 'prata',
  'red' = 'vermelho',
  'blue' = 'azul',
  'brown' = 'marrom',
  'green' = 'verde',
  'beige' = 'bege',
  'orange' = 'laranja',
  'gold' = 'dourado',
  'yellow' = 'amarelo',
  'purple' = 'roxo',
}

export enum enTranslateFuel {
  'gasoline' = 'gasolina',
  'ethanol' = 'álcool',
  'flex' = 'gasolina e álcool',
}

export enum enTranslateSteering {
  'hydraulic' = 'hidráulico',
  'eletric' = 'elétrico',
  'hydraulicEletric' = 'hidráulico e elétrico',
}
